import React from "react";
import { useNavigate } from "react-router-dom";

export default function AddUpdateHeader({ list, modal }) {
  const navigate = useNavigate();
  return (
    <div className="">
      <div className="category-wrapper d-flex justify-content-center flex-column w-100">
        <div className="d-flex  align-items-center sub-head">
          <h4>{modal}</h4>
        </div>
        {/* <button className="border-button" onClick={() => navigate(-1)} >
                        <span>Back to {list}</span>
                    </button> */}
      </div>
    </div>
  );
}
